<template>
  <button
      @click="onclick($event)"
      v-bind:class="type"
      :disabled="disabled"
      sklepalnik-ui-element
      ref="button"
  >
    <img
        v-if="iconFront === 'add'"
        src="./../../assets/icon-add.svg" alt="add"

        class="tw-mr-20"
    />
    <img
        v-if="iconFront === 'camera'"
        src="./../../assets/icon-camera.svg" alt="camera"

        class="tw-mr-20"
    />

    {{ label }}

    <span
        v-if="icon === 'expand' || icon === 'shrink'"
        :class="{ shrink: icon === 'shrink' }"
    >
      <svg
          width="12"
          height="7"
          viewBox="0 0 12 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          :class="{ 'rotate-shrink': icon === 'shrink' }"
      >
        <path
            d="M1 1L6 6L11 1"
            :class="{
            'stroke-white': icon === 'expand',
            'stroke-dark': icon === 'shrink',
          }"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
      </svg>
    </span>

    <div class="border-gap" v-if="type === 'bordered'"></div>
  </button>
</template>

<script>
import {FieldValidatorAcknowledgeFG} from "./FieldValidatorUtils";

export default {
  name: "ui-button",
  props: {
    label: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      validator: (val) =>
          ["primary", "secondary", "flat", "bordered", "red", "white", "flat green"].includes(val),
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    icon: {
      type: String,
      required: false,
      validator: (val) => ["expand", "shrink"].includes(val),
    },
    iconFront: {
      type: String,
      required: false,
      validator: (val) => ["expand", "shrink", "add", "camera"].includes(val),
    },
  },
  data: function () {
    return {
      fg: undefined,
    };
  },
  methods: {
    onclick(e) {
      e.preventDefault();

      if (!this.disabled) {
        this.$emit("click", e);
      }
    },
  },
  mounted: function () {
    FieldValidatorAcknowledgeFG.bind(this)();

    if (this.$el.hasAttribute('fg-progress-next') || this.$el.hasAttribute('fg-submit')) {
      this.$refs.button.setAttribute('type', 'submit');
    } else {
      this.$refs.button.setAttribute('type', 'button');
    }
  },
  destroyed: function () {
    if (this.fg) {
      this.fg.onChildDestroyed(this);
    } else {
      console.log('Error at btn' + this.$el.getAttribute('name'));
    }
  },
};
</script>

<style scoped>
.stroke-white {
  stroke: white;
}

.stroke-dark {
  stroke: #4c4c4c;
}

.rotate-shrink {
  transform: rotateZ(180deg);
}

@media (min-width: 280px) {
  /* galaxy fold */
  button {
    display: inline-flex;
    justify-content: center;
    align-items: center;

    margin: 28px 0 0 0;
    padding: 12px 18px;

    border: 0;
    border-radius: 18px;

    color: #ffffff;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: 2px;
    text-transform: uppercase;

    cursor: pointer;
  }

  button:not(:disabled):focus {
    box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
    outline: 2px solid #1ea89c;
  }

  .primary {
    background: #1ea89c; /* fallback for old browsers */

    background: -webkit-linear-gradient(
        to right,
        #1ea89c,
        #006c68
    ); /* Chrome 10-25, Safari 5.1-6 */

    background: linear-gradient(93.81deg, #1ea89c 0%, #006c68 100%);
  }

  .secondary {
    background: #4c4c4c;
  }

  .red {
    background: linear-gradient(90deg, #ED1C24 0%, #88171D 100%);
  }

  .flat {
    background: transparent;
    color: #4c4c4c;
  }

  .green {
    color: #1EA89C !important;
  }

  .bordered {
    background: transparent;
    color: #4c4c4c;
    border: 1px solid #4c4c4c;

    position: relative;
  }

  .white {
    border: 1px solid #4C4C4C;
    background: white;
    box-shadow: 0px 4px 4px rgba(66, 66, 66, 0.1);
    border-radius: 24px;

    color: #4C4C4C;
  }

  .bordered svg path {
    stroke: #4c4c4c !important;
  }

  .border-gap {
    height: 10px;
    width: 20px;
    background-color: #fafafa;

    position: absolute;
    right: 0;
    bottom: -2px;
  }

  button:disabled {
    opacity: 0.25;
    cursor: default;
  }
}

@media (min-width: 320px) {
  /* smartphones, iPhone, portrait 480x320 phones */
  button {
    margin: 56px 88px 0 88px;
    padding: 16px 24px;
    border-radius: 24px;

    font-weight: 800;
    font-size: 16px;
    line-height: 16px;
  }
}

@media (min-width: 481px) {
  /* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */
}

@media (min-width: 641px) {
  /* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */
}

@media (min-width: 961px) {
  /* tablet, landscape iPad, lo-res laptops and desktops */
}

@media (min-width: 1024px) {
  /* big landscape tablets, laptops, and desktops */
}

@media (min-width: 1281px) {
  /* hi-res laptops and desktops */
}
</style>
